// extracted by mini-css-extract-plugin
export default {"root":"vOn9c","title":"tEtvX","text":"ehAGp"};